import type { ReactNode } from "react";

interface LocationSectionProps {
  heading: string;
  headingHighlight?: string;
  imageSrc: string;
  imageAlt: string;
  imageSide?: "left" | "right";
  imageWidth?: number;
  imageHeight?: number;
  altBackground?: boolean;
  children: ReactNode;
}

export default function LocationSection({
  heading,
  headingHighlight,
  imageSrc,
  imageAlt,
  imageSide = "right",
  imageWidth = 1024,
  imageHeight = 1024,
  altBackground = false,
  children,
}: LocationSectionProps) {
  const imageWrapperClasses =
    imageSide === "left"
      ? "w-full mb-8 lg:float-left lg:w-2/5 lg:mr-12 lg:mb-8"
      : "w-full mb-8 lg:float-right lg:w-2/5 lg:ml-12 lg:mb-8";

  return (
    <section className={altBackground ? "py-20 bg-card" : "py-20"}>
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            {heading}
            {headingHighlight && (
              <>
                {" "}
                <span className="text-gradient-gold">{headingHighlight}</span>
              </>
            )}
          </h2>

          <div className={imageWrapperClasses}>
            <div className="aspect-square rounded-xl overflow-hidden border border-border">
              <img
                src={imageSrc}
                alt={imageAlt}
                width={imageWidth}
                height={imageHeight}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="space-y-6 text-lg text-muted-foreground">
            {children}
          </div>

          <div className="clear-both" />
        </div>
      </div>
    </section>
  );
}
